import initRequestBody from '~/components/distributor/initRequestBody';
import { useGlobalStore } from '~/stores/global';
import { getModelsOffersList } from '~/api/global';
import { useAnalyticsStore } from '~/stores/analytics';
import { useMediaQueryStore } from '~/stores/mediaQuery';

interface loadedObj {
  [id: number]: boolean;
}

export function useListingsLazy(
  getItems: (
    loadFirst?: boolean,
    newFilters?: boolean,
    num?: number
  ) => Promise<any> | void,
  isBot: boolean,
  blocks: number,
  per_page: number,
  isMobile: Ref<boolean>,
  productsList: Ref<HTMLElement | undefined>
) {
  const globalStore = useGlobalStore();
  const analyticsStore = useAnalyticsStore();
  const mediaStore = useMediaQueryStore();
  let intersectNum = 0;
  const intersectPage = Array(blocks).fill(true);
  const inObs = ref<IntersectionObserver>();
  const productsOffers = ref<loadedObj>({});
  const loadedImages = ref<loadedObj>({});
  const isEs = computed(() => mediaStore.isEs);
  onMounted(() => {
    if (!isBot) {
      inObs.value = new IntersectionObserver(onIntersect, {
        rootMargin: '100000px 0px 0px',
      });
      nextTick(() => newObserve());
    }
  });

  onUnmounted(() => {
    if (inObs.value && inObs.value.disconnect instanceof Function)
      inObs.value?.disconnect();
  });

  function beforePageChangeLazy(): void {
    if (!isBot) {
      intersectPage.fill(true);
      intersectNum = 0;
      loadedImages.value = productsOffers.value = {};
      if (inObs.value && inObs.value.disconnect instanceof Function)
        inObs.value?.disconnect();
    }
  }

  function newObserve(key = ''): void {
    setTimeout(() => {
      if (
        !isBot &&
        productsList.value &&
        inObs.value &&
        inObs.value.observe instanceof Function
      ) {
        const card = productsList.value?.querySelectorAll(
          `div.p-card:not(.skeleton)${key}`
        );
        if (card && card.forEach instanceof Function)
          card.forEach((e) => {
            inObs.value?.observe(e);
          });
      }
    }, 60);
  }

  function onIntersect(entries): void {
    entries.forEach((entry) => {
      if (entry.isIntersecting || entry.boundingClientRect.bottom < 0) {
        if (inObs.value && inObs.value.unobserve instanceof Function)
          inObs.value?.unobserve(entry.target);

        if (entry.target.dataset.lazy) {
          ++intersectNum;
          loadedImages.value = {
            ...loadedImages.value,
            [entry.target.dataset.lazy]: true,
          };
        }
        if (!isEs.value && entry.target.dataset.id)
          getProductOffers(entry.target.dataset.id);
        let per = per_page;
        const card = productsList.value?.querySelectorAll(
          `div.p-card:not(.skeleton)`
        );
        if (card && card?.length) per = card.length;
        if (intersectNum === per) {
          const n = Math.ceil(intersectNum / per_page);
          if (intersectPage[n]) getItems(false, false, n + 1);
        }
      }
    });
  }

  async function getProductOffers(id: number) {
    const route = useRoute();
    const reqBody = initRequestBody(route.query);
    if (!productsOffers.value[id]) {
      const res = await getModelsOffersList(id, reqBody, {
        region_id: globalStore.region.id,
        page: 1,
        per_page: 5,
        sem: globalStore.sem || undefined,
        device: globalStore.device || undefined,
        split: analyticsStore.additional?.split || 'a',
        all: globalStore?.debugPanelAll || undefined,
      });
      if (res) {
        productsOffers.value = { ...productsOffers.value, [id]: res.list };
      }
    }
  }

  return {
    beforePageChangeLazy,
    newObserve,
    productsOffers,
    loadedImages,
    intersectPage,
  };
}
